/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum AppStorageKeys {
    Version = 'version',
}
